import { AxiosHttp } from "../config/axios-interceptor";
import CryptoJS from "crypto-js";
var hashcode = CryptoJS.SHA256(
  process.env.REACT_APP_PREFIX +
    process.env.REACT_APP_TOKEN +
    process.env.REACT_APP_SECRETKEY
);

export async function getSymptomList(successCallback) {
  AxiosHttp.post(`/getsymptomlist`, {
    requestType: "182",
    token: hashcode.toString(),
    data: {
      doctorId: "84743113",
      specialityId: 1,
      clinicId: 61,
    },
  })
    .then((response) => {
      successCallback(response.data.data);
    })
    .catch((error) => {
      console.log(error);
    });
}

export async function getMedicalHistory(successCallback) {
  AxiosHttp.post(`/getmedicalhistorylist`, {
    requestType: "182",
    token: hashcode.toString(),
    data: {
      doctorId: "84743113",
      specialityId: 1,
      clinicId: 61,
    },
  })
    .then((response) => {
      successCallback(response.data.data);
    })
    .catch((error) => {
      console.log(error);
    });
}

export async function getInstructions(successCallback) {
  AxiosHttp.post(`/getinstructionlist`, {
    requestType: "182",
    token: hashcode.toString(),
    data: {
      doctorId: "84743113",
      specialityId: 1,
      clinicId: 61,
    },
  })
    .then((response) => {
      successCallback(response.data.data);
    })
    .catch((error) => {
      console.log(error);
    });
}

export async function getLabFindings(doctorId, successCallback) {
  AxiosHttp.post(`/getlabfindings`, {
    requestType: "182",
    token: hashcode.toString(),
    data: {
      doctorId: doctorId,
      specialityId: 1,
      clinicId: 61,
    },
  })
    .then((response) => {
      successCallback(response.data.data);
    })
    .catch((error) => {
      console.log(error);
    });
}

export async function getInvestigation(successCallback) {
  AxiosHttp.post(`/getbethanylabtest`, {
    requestType: "603",
    version: "2.0",
    token: hashcode.toString(),
    data: {
      browserTimeZone: "GMT%2B05:30",
      isFromMobile: true,
      clinicId: "bethany",
    },
  })
    .then((response) => {
      successCallback(response.data.data);
    })
    .catch((error) => {
      console.log(error);
    });
}

export async function getProvisionalList(doctorId, successCallback) {
  AxiosHttp.post(`/getprovisionallist`, {
    requestType: "182",
    token: hashcode.toString(),
    data: {
      doctorId: doctorId,
      specialityId: 1,
      clinicId: 61,
    },
  })
    .then((response) => {
      successCallback(response.data.data);
    })
    .catch((error) => {
      console.log(error);
    });
}

export async function getMedicationList(successCallback) {
  AxiosHttp.post(`/getbethanymedicinelist`, {
    requestType: "601",
    version: "2.0",
    token: hashcode.toString(),
    data: {
      browserTimeZone: "GMT%2B05:30",
      isFromMobile: true,
      clinicId: "bethany",
      type: "DRUGS",
    },
  })
    .then((response) => {
      successCallback(response.data.data);
    })
    .catch((error) => {
      console.log(error);
    });
}

export async function saveSymptom(name, detailData, successCallback) {
  AxiosHttp.post(`/savesymptom`, {
    requestType: "182",
    token: hashcode.toString(),
    data: {
      doctorId: "84743113",
      specialityId: 1,
      clinicId: 61,
      name,
      detailData,
    },
  })
    .then((response) => {
      successCallback(response.data.data);
    })
    .catch((error) => {
      console.log(error);
    });
}

export async function saveInvestigation(name, successCallback) {
  AxiosHttp.post(`/savelabtest`, {
    requestType: "182",
    token: hashcode.toString(),
    data: {
      doctorId: "84743113",
      specialityId: 1,
      clinicId: 61,
      name,
    },
  })
    .then((response) => {
      successCallback(response.data.data);
    })
    .catch((error) => {
      console.log(error);
    });
}

export async function saveLabFindings(name, detailData, successCallback) {
  AxiosHttp.post(`/savelabfindings`, {
    requestType: "182",
    token: hashcode.toString(),
    data: {
      doctorId: "84743113",
      specialityId: 1,
      clinicId: 61,
      name,
      detailData,
    },
  })
    .then((response) => {
      successCallback(response.data.data);
    })
    .catch((error) => {
      console.log(error);
    });
}

export async function saveMedicalHistory(name, successCallback) {
  AxiosHttp.post(`/savemedicalhistory`, {
    requestType: "182",
    token: hashcode.toString(),
    data: {
      doctorId: "84743113",
      specialityId: 1,
      clinicId: 61,
      name,
    },
  })
    .then((response) => {
      successCallback(response.data.data);
    })
    .catch((error) => {
      console.log(error);
    });
}

export async function saveMedicine(name, successCallback) {
  AxiosHttp.post(`/savemedicine`, {
    requestType: "182",
    token: hashcode.toString(),
    data: {
      doctorId: "84743113",
      specialityId: 1,
      clinicId: 61,
      type: "DRUGS",
      name,
    },
  })
    .then((response) => {
      successCallback(response.data.data);
    })
    .catch((error) => {
      console.log(error);
    });
}

export async function saveInstructions(name, successCallback) {
  AxiosHttp.post(`/saveinstruction`, {
    requestType: "182",
    token: hashcode.toString(),
    data: {
      doctorId: "84743113",
      specialityId: 1,
      clinicId: 61,
      name,
    },
  })
    .then((response) => {
      successCallback(response.data.data);
    })
    .catch((error) => {
      console.log(error);
    });
}

export async function saveProvision(name, successCallback) {
  AxiosHttp.post(`/saveprovisionaldiagonosis`, {
    requestType: "182",
    token: hashcode.toString(),
    data: {
      doctorId: "84743113",
      specialityId: 1,
      clinicId: 61,
      name,
    },
  })
    .then((response) => {
      successCallback(response.data.data);
    })
    .catch((error) => {
      console.log(error);
    });
}

export async function followUpSchedule(date, successCallback) {
  AxiosHttp.post(`/followuprequest`, {
    data: {
      browserTimeZone: "GMT%2B05:30",
      doctorId: "11261136",
      patientId: "10283316",
      appointmentId: "10283316323",
      appointmentDate: date,
    },
    requestType: "606",
    token: hashcode.toString(),
  })
    .then((response) => {
      successCallback(response.data.data);
    })
    .catch((error) => {
      console.log(error);
    });
}

export async function getPatientDetails(successCallback) {
  let encryptedurl = localStorage.getItem("token");
  AxiosHttp.post(`/validatepatientdetails`, {
    data: {
      encryptedurl,
    },
    requestType: "1032",
    token: hashcode.toString(),
  })
    .then((response) => {
      successCallback(response.data.data);
    })
    .catch((error) => {
      console.log(error);
    });
}

export async function getDepartmentList(doctorId, successCallback) {
  AxiosHttp.post(`/getdoctorsfordepartment`, {
    requestType: "182",
    token: hashcode.toString(),
    data: {
      doctorId: doctorId,
    },
  })
    .then((response) => {
      successCallback(response.data.data);
    })
    .catch((error) => {
      console.log(error);
    });
}

export async function getSpecialityList(successCallback) {
  return await AxiosHttp.post(`/getdepartments`, {
    data: { type: "department" },
    browserTimeZone: "",
    requestType: 1062,
    token: hashcode.toString(),
  })
    .then((response) => {
      successCallback(response.data.data);
      return response?.data?.data
    })
    .catch((error) => {
      console.log(error);
    });
}

export async function savePrescription(data, successCallback) {
  AxiosHttp.post(`/saveprescriptiondata`, {
    data,
    browserTimeZone: "",
    requestType: 1062,
    token: hashcode.toString(),
  })
    .then((response) => {
      successCallback(response.data.data);
    })
    .catch((error) => {
      console.log(error);
    });
}

export async function autosavePrescription(data, successCallback) {
  AxiosHttp.post(`/autosaveprescription`, {
    data,
    browserTimeZone: "",
    requestType: 1065,
    token :hashcode.toString(),
  })
    .then((response) => {
      successCallback(response.data.data);
    })
    .catch((error) => {
      console.log(error);
    });
}

export async function getDoctorList(departmentId, successCallback) {
  AxiosHttp.post(`/getdoctors`, {
    data: { type: "doctor", departmentId },
    browserTimeZone: "",
    requestType: 1063,
    token: hashcode.toString(),
  })
    .then((response) => {
      successCallback(response.data.data);
    })
    .catch((error) => {
      console.log(error);
    });
}

export async function getLastPrescriptionAvailability(
  appId,
  doctorCode,
  patientNo,
  successCallback
) {
  AxiosHttp.post(`/preloadenable`, {
    requestType: "1055",
    data: {
      AppId: appId,
      doctorcode: doctorCode,
      patientNO: patientNo,
    },
    token: hashcode.toString(),
  })
    .then((response) => {
      successCallback(response.data.data);
    })
    .catch((error) => {
      console.log(error);
    });
}

export async function getLastPrescription(
  appId,
  doctorCode,
  patientNo,
  successCallback
) {
  AxiosHttp.post(`/preloadprescription`, {
    version: 1,
    requestType: "1054",
    token: hashcode.toString(),
    data: {
      appointmentId: appId,
      doctorcode: doctorCode,
      patientNO: patientNo,
    },
  })
    .then((response) => {
      successCallback(response.data.data);
    })
    .catch((error) => {
      console.log(error);
    });
}

export async function createTemplate(data, successCallback) {
  AxiosHttp.post(`/createtemplate`, {
    version: 1,
    requestType: "1054",
    token: hashcode.toString(),
    data,
    browserTimeZone: "",
  })
    .then((response) => {
      successCallback(response.data.data);
    })
    .catch((error) => {
      console.log(error);
    });
}

export async function updateTemplate(data, successCallback) {
  AxiosHttp.post(`/updatetemplate`, {
    version: 1,
    requestType: "1054",
    token: hashcode.toString(),
    data,
  })
    .then((response) => {
      successCallback(response.data.data);
    })
    .catch((error) => {
      console.log(error);
    });
}

export async function getTemplates(searchText, offset, successCallback) {
  AxiosHttp.post(`/gettemplatelist`, {
    data: {
      type: "templateList",
      offset,
      version: 2,
      searchText,
    },
    browserTimeZone: "GMT+05:30",
    requestType: 1070,
    token: hashcode.toString(),
  })
    .then((response) => {
      successCallback(response.data.data);
    })
    .catch((error) => {
      console.log(error);
    });
}

export async function viewTemplates(templateId, successCallback) {
  AxiosHttp.post(`/viewtemplate`, {
    data: {
      templateId: templateId,
    },
    browserTimeZone: "GMT+05:30",
    requestType: 1068,
    token: hashcode.toString(),
  })
    .then((response) => {
      successCallback(response.data.data);
    })
    .catch((error) => {
      console.log(error);
    });
}

export async function getmappedtemplateAvailability(
  doctorCode,
  successCallback
) {
  AxiosHttp.post(`/getmappedtemplates`, {
    requestType: "1055",
    data: {
      doctorId: doctorCode,
    },
    token: hashcode.toString(),
  })
    .then((response) => {
      successCallback(response.data.data);
    })
    .catch((error) => {
      console.log(error);
    });
}

export async function getPrescriptionAvailability(
  consultationId,
  successCallback
) {
  AxiosHttp.post(`/precriptiondata`, {
    requestType: "231",
    data: {
      consultationId: consultationId,
    },
    token: hashcode.toString(),
  })
    .then((response) => {
      successCallback(response.data.data);
    })
    .catch((error) => {
      console.log(error);
    });
}
